import React, { useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { Copy, Check, Sun, CalendarBlank, Barbell, Users, Trophy, Heart, Lightning, PaperPlaneTilt, ClockCounterClockwise } from "@phosphor-icons/react";

/* ─────────────────────────── DONNÉES HORAIRE ─────────────────────────────── */
const SEMAINE = [
  { jour: "Lundi", heure: "19h00 – 20h15", cours: "Juniors 14–17", ouvert: true },
  { jour: "Mardi", heure: "18h00 – 19h15", cours: "Kickboxing / Muay-Thaï", ouvert: true },
  { jour: "Mercredi", heure: "19h00 – 20h15", cours: "Juniors 14–17", ouvert: true },
  { jour: "Jeudi", heure: "18h00 – 19h15", cours: "Kickboxing / Muay-Thaï", ouvert: true },
  { jour: "Vendredi", heure: "—", cours: "Fermé (repos · famille · structure)", ouvert: false },
  { jour: "Samedi", heure: "Voir samedis spéciaux", cours: "1 samedi sur 2 — thème spécial", ouvert: true },
  { jour: "Dimanche", heure: "—", cours: "Fermé", ouvert: false },
];

const THEMES = [
  { key: "technique", label: "Technique & Progression", icon: Barbell, desc: "Révision des bases, travail des ceintures, cahier athlète, corrections individuelles.", color: "#D90429" },
  { key: "competition", label: "Compétition & Arbitrage", icon: Trophy, desc: "Rounds, gestion du stress, règles, arbitrage éducatif, préparation des tournois.", color: "#BF8C00" },
  { key: "communaute", label: "Communauté & Famille", icon: Heart, desc: "Parents-enfants, défis, jeux, mini-tournois internes, portes ouvertes, amène un ami.", color: "#2A9D8F" },
  { key: "performance", label: "Performance & Conditionnement", icon: Lightning, desc: "Cardio, mobilité, renforcement, mental, objectifs individuels, récupération.", color: "#5B8DEF" },
];

const SAMEDIS = [
  { mois: "Juillet", items: [
    { label: "Samedi 1 — OUVERT", theme: "Technique & Progression", horaire: "9h30 – 11h30 (2 blocs)" },
    { label: "Samedi 2 — fermé", theme: "", horaire: "" },
    { label: "Samedi 3 — OUVERT", theme: "Compétition & Arbitrage", horaire: "9h30 – 11h30 (2 blocs)" },
    { label: "Samedi 4 — fermé", theme: "", horaire: "" },
  ]},
  { mois: "Août", items: [
    { label: "Samedi A — OUVERT", theme: "Pré-rentrée technique (mise à niveau, tests)", horaire: "9h30 – 11h30" },
    { label: "Samedi B — OUVERT", theme: "Simulation de compétition / sparring encadré", horaire: "9h30 – 11h30" },
    { label: "Samedi C — OUVERT", theme: "Portes ouvertes · amène un ami · découverte", horaire: "9h30 – 11h30" },
  ]},
];

const BLOCS = [
  { h: "Bloc 1 · 9h30 – 10h15", d: "Tous niveaux jeunes (Dynamo, petits) ou « Bouge en famille »." },
  { h: "Bloc 2 · 10h30 – 11h30", d: "Atelier technique / compétition (pour ceux qui veulent pousser)." },
];

/* ─────────────────────────── MESSAGES PRÊTS ──────────────────────────────── */
const MSG_EMAIL = `Bonjour à tous,

Pour l'été, notre école restera active, mais avec un horaire un peu plus léger. Nous allons maintenir certains cours en semaine et ouvrir aussi certains samedis afin de permettre aux jeunes et aux familles de venir bouger pendant l'été.

L'objectif de cette période est de garder nos élèves actifs, continuer à faire progresser nos groupes, tester certaines améliorations dans notre structure et préparer la prochaine étape pour nos programmes et nos compétitions.

Cet été sera un peu plus tranquille, mais je serai bien présent pour continuer à améliorer notre système, notre organisation et l'encadrement offert à vos enfants.

Je vous enverrai sous peu un horaire d'été plus précis, incluant les samedis où il sera possible de venir s'entraîner.

— Ralph · Impact Kick-Boxing`;

const MSG_FB = `Petit mot pour vous annoncer notre HORAIRE D'ÉTÉ à Impact Kick-Boxing 👊

On garde nos cours réguliers en semaine :
• Lundi 19h : Juniors 14–17
• Mardi 18h : Kickboxing / Muay-Thaï
• Mercredi 19h : Juniors 14–17
• Jeudi 18h : Kickboxing / Muay-Thaï

Nouveauté : certains SAMEDIS seront ouverts cet été avec des thèmes spéciaux :
• Technique & progression
• Compétition & arbitrage
• Activités familles / parents-enfants
• Conditionnement & performance

L'objectif : garder vos jeunes actifs et motivés, tout en me laissant du temps pour continuer à améliorer notre système et nos programmes pour la prochaine saison.

Je vous envoie bientôt les dates précises des samedis avec les thèmes.
Merci pour votre confiance, on continue à bâtir ça ensemble 💪

Ralph · Impact Kick-Boxing`;

const MSG_SMS = `Salut ! Pour l'été on garde les cours réguliers (lun/mer juniors, mar/jeu kickboxing/Muay-Thaï) et on ajoute certains samedis spéciaux (technique, compétition, famille, conditionnement). Je t'envoie bientôt les dates exactes des samedis. Merci pour ton soutien, on continue de faire grandir l'école ensemble 💪`;

const MSG_RENCONTRE = `Bonjour à tous,

Merci à celles et ceux qui ont pu se joindre à notre rencontre. Voici un résumé pour que tout le monde soit au même niveau d'information, présents comme absents.

CE QU'ON A PRÉSENTÉ
• Où nous en sommes : la réalité d'une école privée de sports et nos défis actuels.
• Notre nouvelle plateforme de gestion (inscriptions, paiements, communications) et ce qu'elle change dans le quotidien.
• La structure des programmes de compétition, la formation des coachs et les compétitions inter-écoles.
• Le rôle de chacun : direction, professeurs, parents et athlètes.

NOS ENGAGEMENTS COMME DIRECTION
• Travailler sur notre système et notre structure.
• Collaborer avec vous pour trouver des solutions durables.
• Donner notre 200 % pour le développement de vos enfants, autant sportif qu'humain.

COMMENT VOUS POUVEZ VOUS IMPLIQUER
Chacun à sa mesure : présence aux activités, encouragement, bénévolat ponctuel, transport, partage de nos publications. Chaque geste aide l'école et le sport à grandir dans la communauté.

PROCHAINES ÉTAPES
• Horaire d'été (cours en semaine + samedis spéciaux) — détails envoyés séparément.
• Suite de la mise en place de la plateforme et de la structure de compétition.

Si vous avez des questions ou des points à aborder, répondez simplement à ce courriel.
Merci de votre confiance — on continue à bâtir ça ensemble.
— Ralph · Institut Impact Élite Martial`;

function CopyBtn({ text, testId }) {
  const [done, setDone] = useState(false);
  return (
    <button
      onClick={() => {
        navigator.clipboard.writeText(text).then(() => {
          setDone(true); toast.success("Copié !"); setTimeout(() => setDone(false), 1800);
        });
      }}
      data-testid={testId}
      className="inline-flex items-center gap-1.5 bg-zinc-900 hover:bg-[#D90429] text-white text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors"
    >
      {done ? <Check size={14} weight="bold" /> : <Copy size={14} />} {done ? "Copié" : "Copier"}
    </button>
  );
}

function RencontreRappel({ onSent }) {
  const [date, setDate] = useState("");
  const [heure, setHeure] = useState("");
  const [lieu, setLieu] = useState("");
  const [busy, setBusy] = useState(false);

  async function send() {
    setBusy(true);
    try {
      const c = await api.get("/horaire-ete/recipients-count");
      const count = c?.data?.count ?? 0;
      if (count === 0) { toast.info("Aucune famille active avec courriel valide."); setBusy(false); return; }
      const quand = [date, heure].filter(Boolean).join(" · ") || "(date à confirmer)";
      if (!window.confirm(`Envoyer le RAPPEL DE RENCONTRE à ${count} famille(s) ?\n\nQuand : ${quand}\nLieu : ${lieu || "Institut Impact Élite Martial"}\n\n⚠️ Envoi réel via Gmail (production).`)) {
        setBusy(false); return;
      }
      const r = await api.post("/rencontre-rappel/send-all", { date, heure, lieu, base_url: window.location.origin });
      toast.success(`✅ Rappel envoyé à ${r.data.sent} famille(s) !`);
      onSent && onSent();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Envoi échoué (vérifie Gmail)");
    }
    setBusy(false);
  }

  return (
    <div className="border border-zinc-200 rounded-lg bg-white p-4" data-testid="rencontre-rappel-card">
      <div className="font-semibold text-zinc-900 text-sm">Rappel de rencontre (parents · élèves · coachs)</div>
      <div className="text-xs text-zinc-500 mt-0.5 mb-3">Invitation + ordre du jour. Remplis la date, l'heure et le lieu avant d'envoyer.</div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 mb-3">
        <input value={date} onChange={(e) => setDate(e.target.value)} placeholder="Date (ex. samedi 21 juin)" data-testid="rappel-date"
          className="border border-zinc-300 rounded px-2.5 py-1.5 text-sm text-zinc-900" />
        <input value={heure} onChange={(e) => setHeure(e.target.value)} placeholder="Heure (ex. 18h30)" data-testid="rappel-heure"
          className="border border-zinc-300 rounded px-2.5 py-1.5 text-sm text-zinc-900" />
        <input value={lieu} onChange={(e) => setLieu(e.target.value)} placeholder="Lieu" data-testid="rappel-lieu"
          className="border border-zinc-300 rounded px-2.5 py-1.5 text-sm text-zinc-900" />
      </div>
      <button onClick={send} disabled={busy} data-testid="send-rencontre-rappel-btn"
        className="inline-flex items-center gap-2 bg-[#D90429] hover:bg-[#a80320] disabled:opacity-50 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors">
        <PaperPlaneTilt size={16} weight="fill" /> {busy ? "Envoi…" : "Envoyer le rappel de rencontre"}
      </button>
    </div>
  );
}

function BulkSend({ title, desc, endpoint, testId, onSent }) {
  const [busy, setBusy] = useState(false);

  async function send() {
    setBusy(true);
    try {
      const c = await api.get("/horaire-ete/recipients-count");
      const count = c?.data?.count ?? 0;
      if (count === 0) {
        toast.info("Aucune famille active avec courriel valide.");
        setBusy(false);
        return;
      }
      if (!window.confirm(`Envoyer « ${title} » par courriel à ${count} famille(s) ?\n\n⚠️ Envoi réel via Gmail (production).`)) {
        setBusy(false);
        return;
      }
      const r = await api.post(endpoint, { base_url: window.location.origin });
      toast.success(`✅ Envoyé à ${r.data.sent} famille(s) !`);
      onSent && onSent();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Envoi groupé échoué (vérifie Gmail)");
    }
    setBusy(false);
  }

  return (
    <div className="flex items-center justify-between gap-3 border border-zinc-200 rounded-lg bg-white p-4">
      <div>
        <div className="font-semibold text-zinc-900 text-sm">{title}</div>
        <div className="text-xs text-zinc-500 mt-0.5">{desc}</div>
      </div>
      <button
        onClick={send}
        disabled={busy}
        data-testid={testId}
        className="inline-flex items-center gap-2 bg-[#D90429] hover:bg-[#a80320] disabled:opacity-50 text-white text-sm font-semibold px-4 py-2 rounded-lg transition-colors whitespace-nowrap"
      >
        <PaperPlaneTilt size={16} weight="fill" /> {busy ? "Envoi…" : "Envoyer en groupe"}
      </button>
    </div>
  );
}

const KIND_LABEL = {
  horaire_ete: "Horaire d'été",
  rencontre_parents: "Résumé rencontre parents",
};

function JournalEnvois({ refreshKey }) {
  const [rows, setRows] = useState([]);

  React.useEffect(() => {
    api.get("/communications/journal").then((r) => setRows(r.data?.envois || [])).catch(() => {});
  }, [refreshKey]);

  if (rows.length === 0) return null;
  return (
    <div className="mt-4 border border-zinc-200 rounded-lg bg-zinc-50 p-4" data-testid="journal-envois">
      <div className="text-xs uppercase tracking-wide text-zinc-400 mb-2 flex items-center gap-1.5">
        <ClockCounterClockwise size={14} /> Journal des envois
      </div>
      <div className="divide-y divide-zinc-200">
        {rows.map((e) => (
          <div key={e.id} className="flex items-center justify-between gap-3 py-2 text-sm" data-testid="journal-row">
            <div className="text-zinc-700">
              {KIND_LABEL[e.kind] || e.subject}
              <span className="text-zinc-400"> · {e.recipients_count} destinataire(s)</span>
            </div>
            <div className="text-xs text-zinc-400 whitespace-nowrap">
              {new Date(e.sent_at).toLocaleString("fr-CA", { dateStyle: "medium", timeStyle: "short" })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function HoraireEteModule() {
  const [journalKey, setJournalKey] = useState(0);
  const refreshJournal = () => setJournalKey((k) => k + 1);
  return (
    <div className="p-6 md:p-8 max-w-5xl mx-auto" data-testid="horaire-ete-module">
      <div className="flex items-center gap-2 text-[#D90429]">
        <Sun size={22} weight="fill" />
        <h1 className="text-2xl font-bold text-zinc-900">Horaire d'été 2026</h1>
      </div>
      <p className="text-sm text-zinc-500 mt-1 max-w-2xl">
        École active mais allégée (juillet–août) : cours réguliers en semaine + certains samedis à thème.
        L'objectif : garder les jeunes actifs, maintenir le lien avec les familles et préparer la rentrée.
      </p>

      {/* En semaine */}
      <h2 className="text-lg font-semibold text-zinc-800 mt-8 flex items-center gap-2">
        <CalendarBlank size={18} className="text-zinc-500" /> En semaine
      </h2>
      <div className="mt-3 border border-zinc-200 rounded-lg overflow-hidden bg-white" data-testid="semaine-grid">
        {SEMAINE.map((s) => (
          <div key={s.jour} className={`flex items-center gap-4 px-4 py-3 border-b border-zinc-100 last:border-0 ${s.ouvert ? "" : "bg-zinc-50"}`}>
            <div className="w-24 font-semibold text-zinc-900">{s.jour}</div>
            <div className="w-40 text-sm text-zinc-500">{s.heure}</div>
            <div className={`flex-1 text-sm ${s.ouvert ? "text-zinc-800" : "text-zinc-400"}`}>{s.cours}</div>
            <span className={`w-2.5 h-2.5 rounded-full ${s.ouvert ? "bg-[#2A9D8F]" : "bg-zinc-300"}`} />
          </div>
        ))}
      </div>
      <p className="text-xs text-zinc-400 mt-2">Dynamo 8–13 : formule été 1 à 2 fois par semaine selon les inscriptions.</p>

      {/* Samedis */}
      <h2 className="text-lg font-semibold text-zinc-800 mt-8 flex items-center gap-2">
        <Sun size={18} className="text-[#BF8C00]" /> Samedis spéciaux
      </h2>
      <div className="grid sm:grid-cols-2 gap-4 mt-3">
        {SAMEDIS.map((m) => (
          <div key={m.mois} className="border border-zinc-200 rounded-lg bg-white p-4" data-testid={`samedis-${m.mois.toLowerCase()}`}>
            <div className="font-semibold text-zinc-900 mb-2">{m.mois}</div>
            {m.items.map((it, i) => (
              <div key={i} className="flex items-start justify-between gap-2 py-1.5 border-b border-zinc-100 last:border-0">
                <div>
                  <div className={`text-sm font-medium ${it.theme ? "text-zinc-800" : "text-zinc-400"}`}>{it.label}</div>
                  {it.theme && <div className="text-xs text-zinc-500">{it.theme}</div>}
                </div>
                {it.horaire && <div className="text-xs text-zinc-400 whitespace-nowrap">{it.horaire}</div>}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Format des blocs */}
      <div className="mt-3 border border-zinc-200 rounded-lg bg-zinc-50 p-4">
        <div className="text-xs uppercase tracking-wide text-zinc-400 mb-2">Format d'un samedi ouvert</div>
        {BLOCS.map((b, i) => (
          <div key={i} className="text-sm text-zinc-700 py-0.5"><b>{b.h}</b> — {b.d}</div>
        ))}
      </div>

      {/* Thèmes */}
      <h2 className="text-lg font-semibold text-zinc-800 mt-8">Les 4 thèmes des samedis</h2>
      <div className="grid sm:grid-cols-2 gap-3 mt-3">
        {THEMES.map((t) => {
          const Icon = t.icon;
          return (
            <div key={t.key} className="border border-zinc-200 rounded-lg bg-white p-4 flex gap-3" data-testid={`theme-${t.key}`}>
              <Icon size={22} weight="fill" style={{ color: t.color }} className="flex-shrink-0 mt-0.5" />
              <div>
                <div className="font-semibold text-zinc-900 text-sm">{t.label}</div>
                <div className="text-xs text-zinc-500 mt-0.5">{t.desc}</div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Envoi groupé aux familles */}
      <h2 className="text-lg font-semibold text-zinc-800 mt-10 flex items-center gap-2">
        <PaperPlaneTilt size={18} className="text-[#D90429]" /> Envoi groupé aux familles (Gmail)
      </h2>
      <p className="text-xs text-zinc-400 mt-1 max-w-2xl">
        Un seul courriel envoyé en copie cachée (BCC) à toutes les familles actives. Le nombre de
        destinataires est confirmé avant chaque envoi.
      </p>
      <div className="space-y-3 mt-3" data-testid="bulk-send-section">
        <BulkSend
          title="Horaire d'été 2026"
          desc="Cours en semaine + samedis spéciaux, mise en page complète."
          endpoint="/horaire-ete/send-all"
          testId="send-horaire-ete-btn"
          onSent={refreshJournal}
        />
        <BulkSend
          title="Résumé de la rencontre de parents"
          desc="Suivi post-rencontre : vision, structure, engagements et implication."
          endpoint="/rencontre-parents/send-all"
          testId="send-rencontre-btn"
          onSent={refreshJournal}
        />
        <RencontreRappel onSent={refreshJournal} />
      </div>
      <JournalEnvois refreshKey={journalKey} />

      {/* Messages prêts */}
      <h2 className="text-lg font-semibold text-zinc-800 mt-10 flex items-center gap-2">
        <Users size={18} className="text-zinc-500" /> Messages prêts à envoyer aux familles
      </h2>
      <div className="space-y-4 mt-3">
        {[
          { id: "email", title: "Courriel aux parents (horaire d'été)", text: MSG_EMAIL },
          { id: "rencontre", title: "Courriel résumé de la rencontre de parents", text: MSG_RENCONTRE },
          { id: "facebook", title: "Publication Facebook", text: MSG_FB },
          { id: "sms", title: "WhatsApp / SMS (court)", text: MSG_SMS },
        ].map((msg) => (
          <div key={msg.id} className="border border-zinc-200 rounded-lg bg-white p-4" data-testid={`msg-${msg.id}`}>
            <div className="flex items-center justify-between mb-2">
              <div className="font-semibold text-zinc-900 text-sm">{msg.title}</div>
              <CopyBtn text={msg.text} testId={`copy-${msg.id}`} />
            </div>
            <pre className="text-xs text-zinc-600 whitespace-pre-wrap font-sans leading-relaxed">{msg.text}</pre>
          </div>
        ))}
      </div>
    </div>
  );
}
